import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { ClientService } from 'src/app/service/client.service';
import { listChanges } from 'angularfire2/database';
import { Client } from 'src/app/entity/exhibitor';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-liste-archivee',
  templateUrl: './liste-archivee.component.html',
  styleUrls: ['./liste-archivee.component.css']
})
export class ListeArchiveeComponent implements OnInit,OnChanges {
  listArchives:  Observable<Client[]> ;
  @Input() index:number;
  
  cols: any[];
  types: any[];

  constructor(private clientService:ClientService) {
    this.cols = [
      { field: 'raisonSocial', header: 'Raison Social' ,width:'40%'} , 
      { field: 'observation', header: 'Note',width:'30%' } ,
      { field: 'type', header: 'Type',width:'20%' } ,
      { field: 'dateEdit', header: 'Date Archive' ,width:'10%' },
  ];
  this.types = [
    { label: 'Exposant', value: "AE" },
    { label: 'Co-Exposant', value: 'AC' },
    { label: 'Délégué', value: 'AD' },
    { label: 'Exposant Sponsor', value: 'AES' },

];
   }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.index==4 && !this.listArchives)
   this.listArchives= this.clientService.findArchives();
  }

  ngOnInit() {

  }
  convertType(t:string):string{
    let type:string;
  if(t=="AE")
  type="Exposant"
  else if(t=="AES")
  type = "Exposant Sponsor"
  else if(t=="AC")
  type="Co-Exposant"
  else if(t=="AD")
  type="Délégué"
  return type;
  }
  
}
